<template>
  <div
    class="user-icon"
    :style="`width: ${size}px; height: ${size}px;`">
    <img
      v-if="imageSrc && isCorrectImage"
      class="user-image"
      contain
      :height="size + 'px'"
      :src="imageSrc"
      :style="`min-width: ${size}px; min-height: ${size}px; --color: ${borderColor}`"
      :width="size + 'px'"
      @error="isCorrectImage = false">
    <v-avatar
      v-else
      :class="{'without-border': !border}"
      color="user-avatar"
      :height="size + 'px'"
      :min-width="size + 'px'"
      :style="`--color: ${borderColor}`"
      :title="name"
      :width="size + 'px'">
      <slot/>
      <span v-if="!$slots.default">
        {{ initials || name }}
      </span>
    </v-avatar>
  </div>
</template>

<script>
export default {
  name: 'userIcon',
  data() {
    return {
      isCorrectImage: true
    }
  },
  props: {
    src: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    name: {
      type: String
    },
    border: {
      type: Boolean,
      default: true
    },
    borderColor: {
      type: String,
      default: 'var(--white-color)'
    },
  },
  computed: {
    imageSrc() {
      let result = this.src
      result = result ?? (this.name === 'Робот SmartTender' ? '/img/robot.svg' : null)
      return result && typeof result == 'string' ? result : null
    },
    initials() {
      return this.name?.split(' ').map(el => el[0]).join('')
    }
  }
}
</script>

<style scoped>
.user-image {
  display: flex;
  border-radius: 50%;
  color: var(--color) !important;
  border: 2px solid var(--color) !important;
  max-width: 100%;
  max-height: 100%;
}

.user-icon {
  max-width: min-content;
}
</style>
<style lang="scss">
.user-avatar.v-avatar{
  font-size: 11px !important;
  color: var(--color) !important;
  border: 2px solid var(--color);
  background-color: var(--v-main__green-base) !important;
  &.without-border {
    border: 0px solid transparent;
  }
}
</style>
